import { render, staticRenderFns } from "./page.vue?vue&type=template&id=418a06e1&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=418a06e1&scoped=true&lang=less&"
import style1 from "./page.vue?vue&type=style&index=1&id=418a06e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a06e1",
  null
  
)

export default component.exports